import { TrackingService } from '../../../common/tracking/trackingService';
import { trackClickEvent } from '../../../modules/GlintsTracking/tracking';

export function trackVIPExpiredNavbarBannerImpression() {
  TrackingService.logEvent('vip_expired_navbar_banner_impression');
}

export function trackVIPExpiredNavbarBannerCTAClicked() {
  TrackingService.logEvent('vip_expired_navbar_banner_cta_clicked');
  trackClickEvent({
    elementName: 'vip_expired_navbar_banner_cta',
  });
}
